const fontSize = {
  xxxs: "clamp(0.6875rem, (12 / 1920) * 100vw, 0.75rem)",  //14-12
  xxs: "clamp(0.75rem, (14 / 1920) * 100vw, 0.875rem)",  //14-12
  xs: "clamp(0.875rem, (16 / 1920) * 100vw, 1rem)",  //16-14
  s: "clamp(1rem, (18 / 1920) * 100vw, 1.125rem)",  //18-16
  m: "clamp(1.25rem, (24 / 1920) * 100vw, 1.5rem)", //24-20
  l: "clamp(1.75rem, (32 / 1920) * 100vw, 2rem)",  // 32-28
  xl: "clamp(2rem, (40 / 1920) * 100vw, 2.25rem)", //36-32
  xxl: "clamp(3.125rem, (56 / 1920) * 100vw, 3.5rem)", //56-50
};
export default fontSize;
